import toast from 'react-hot-toast'
import { HiOutlineClipboardCheck } from 'react-icons/hi'
import Toast from 'components/Toast'

export const copyToClipboard = (e: React.MouseEvent<HTMLButtonElement>) => {
  e.preventDefault()
  const text = e.currentTarget.getAttribute('data-clipboard-text')
  navigator.clipboard.writeText(text as string)

  const toastContent = () => (
    <>
      <p className="text-sm font-medium text-gray-900">Copied to Clipboard</p>
      <p className="mt-1 text-sm text-gray-500 truncate">{text}</p>
    </>
  )

  toast.custom((t) => <Toast t={t} content={toastContent()} icon={HiOutlineClipboardCheck} />, {
    id: 'clipboard'
  })
}
